import { defineStore } from 'pinia';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { removeRouteListener } from '@/utils/route-listener';
import { appRoutes } from '@/router/routes'
import { UserState } from './types';
import useAppStore from '../app';

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    name: undefined,
    avatar: undefined,
    job: undefined,
    organization: undefined,
    location: undefined,
    email: undefined,
    introduction: undefined,
    personalWebsite: undefined,
    jobName: undefined,
    organizationName: undefined,
    locationName: undefined,
    phone: undefined,
    registrationDate: undefined,
    accountId: undefined,
    certification: undefined,
    role: '',
    loading: false,
    loadingTip: '加载中...',
    token: {},
    profilesUserInfo:{},
    menuRouters: [],
    defaultRoute: ''
  }),

  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    },
  },

  actions: {
    switchRoles() {
      return new Promise((resolve) => {
        this.role = this.role === 'user' ? 'admin' : 'user';
        resolve(this.role);
      });
    },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },

    // Reset user's information
    resetInfo() {
      this.$reset();
    },
    logoutCallBack() {
      const appStore = useAppStore();
      this.resetInfo();
      removeToken();
      removeRouteListener();
      appStore.clearServerMenu();
    },
    setLoading(val:boolean) {
      this.loading = val
    },
    setLoadingTip(tip: string) {
      this.loadingTip = tip
    },
    setToken(){
      const raw = getToken()
      if (raw && raw.indexOf('.') != -1) {
        const payload = raw.split('.')[1]
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
        const binary = window.atob(padded)
        const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
        this.token = JSON.parse(new TextDecoder().decode(bytes))
      }
    },
    setProfilesUserInfo(val:object){
      this.profilesUserInfo = val
    },
    setMenuRouters(val:any){
      this.menuRouters = appRoutes.filter(item=> item.name == val)
    },
    setDefaultRoute(path: string) {
      this.defaultRoute = path;
    },
  },
});

export default useUserStore;
